import { useState, type FormEvent } from 'react';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9p0araftmtnfcfh0f30';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    setErrorMsg('');

    try {
      const formData = new FormData(e.currentTarget);
      const honeypot = formData.get('website_alt') as string;
      if (honeypot && honeypot.trim() !== '') {
        setStatus('success');
        setEmail('');
        return;
      }

      const res = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(text); } catch { parsed = {}; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
        setErrorMsg(msg.includes('spam') ? '提交失败，请稍后再试' : msg || '订阅失败，请稍后再试');
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请检查网络连接后重试');
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <section className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-6">
            <i className="ri-check-line text-3xl text-accent-500"></i>
          </div>
          <h2 className="font-heading text-2xl font-bold text-foreground-900">订阅成功！</h2>
          <p className="mt-3 text-sm text-foreground-500">
            感谢您的订阅！您将第一时间收到最新漫画更新通知。
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-6">
          <i className="ri-mail-send-line text-2xl text-primary-500"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
          订阅更新通知
        </h2>
        <p className="mt-3 text-sm text-foreground-500">
          第一时间获取最新<strong>韩漫</strong>更新、新作上线和热门推荐，不错过任何精彩内容。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="mt-8 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="输入您的邮箱地址"
            className="w-full px-4 py-3 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 text-sm font-semibold rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status === 'error' && (
          <div className="mt-4 flex items-center justify-center gap-2 text-sm text-red-600">
            <i className="ri-error-warning-line"></i>
            <span>{errorMsg}</span>
          </div>
        )}

        <p className="mt-4 text-xs text-foreground-400">
          我们尊重您的隐私，不会发送垃圾邮件
        </p>
      </div>
    </section>
  );
}